module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-small-content"
  }, [_c('div', {
    staticClass: "block-small-content-text"
  }, [_vm._v("\n    " + _vm._s(_vm.typeText) + " " + _vm._s(_vm.textClock) + " " + _vm._s(_vm.item.startTime) + " " + _vm._s(_vm.postponedText) + " " + _vm._s(_vm.canceledText)), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.textLink,
      "title": _vm.item.title
    }
  }, [_vm._v(_vm._s(_vm.item.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-238d6418"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/SliderItemInformation.vue
// module id = 93
// module chunks = 1